export const displayId = (id: string | number, repeat = 6) => {
    if(id && String(id).length > 6){
        return String(id);
    }else if(!id){
        return "";
    }else{
        return String(id).padStart(repeat, "0");
    }
}